import React, {Component} from 'react';
import '../assets/styles/proshows.scss';
import TestImg from '../assets/images/competitions/culty/standup.JPG';
import ProshowsCard from '../components/ProshowsCard';
import ReactFullpage from "@fullpage/react-fullpage";
import ProshowImg from '../assets/images/proshows-bg.jpg';
import ZakirKhan from '../assets/images/competitions/proshows/zakir.jpeg';
import {Icon, List, Menu} from "semantic-ui-react";
import {NavLink} from 'react-router-dom';
import SuhaniShah from '../assets/images/competitions/proshows/suhani_shah.jpeg';
import Shriya from '../assets/images/competitions/proshows/shriya.jpeg';
import Nalayak from '../assets/images/competitions/proshows/nalayak.jpeg';

class Proshows extends Component {

    constructor() {
        super();
        this.data=[
            {
                name:'Comedy Night with Zakir Khan',
                photo:ZakirKhan,
                submit:'https://forms.gle/MbYYoGoJpbJdngcs6',
                details:'We are here with one of the most celebrated comedian - Zakir Khan . A writer by profession, this \'Confused Desi\' serves his take on modern India, with a hard-to-resist style of humour that will have you nodding your heads and clapping as you will relate to everything he says. \n' +
                    '\n' +
                    'Gear up to cherish the moments of laughter and joy. Don\'t miss his performance on Saturday March 13th 6:00 PM.',

            },
            {
                name:'Suhani Shah',
                photo:SuhaniShah,
                submit:null,
                details:'Do you want to get awestruck by wonderful illusions and mentalism ??\n' +
                    '\n' +
                    'We gladly present you the only female Mentalist, Magician and Illusionist in India - Suhani Shah . A professional hypnotherapist who started her career as a Magician just at an age of 7 ! Suhani Shah has performed so many shows and was invited to several TED Talks as well.\n' +
                    '\n' +
                    'Get ready to witness an amazing performance and enjoy the moments of magic and illusions on March 12th 6 PM IST.',

            },
            {
                name:'Shriya Pilgaonkar',
                photo:Shriya,
                submit:null,
                details:'Elan & ηVision 2021 in association with Clustera are delighted to present to you on the 12th of March 7:30 PM IST, the beautiful actress - Shriya Pilgaonkar. Catch her up while talking about her career and the ups and downs of her wonderful journey.',

            },
            {
                name:'Indie Rock - Naalayak',
                photo:Nalayak,
                submit:null,
                details:'Elan & ηVision 2021 and Campus Events Private Limited are delighted to present to you on the 14th of March 6 PM IST, Naalayak.\n' +
                    '\n' +
                    'Defined by its enchanting stage persona, Naalayak , is an emerging, first of its kind, independent rock band from Chandigarh. Applauded for the crazy acts and stupefying live performances, Naalayak’s music gently teases the bizarreness of the “Modern Society”.',

            },
            // {
            //     name: "Proshows 2",
            //     photo: TestImg,
            //     details:
            //         "A new music service with official albums, singles, videos, remixes, live performances and more for Android, iOS and desktop. It's all here. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
            // },
            // {
            //     name: "Proshows 3",
            //     photo: TestImg,
            //     details:
            //         "A new music service with official albums, singles, videos, remixes, live performances and more for Android, iOS and desktop. It's all here. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
            // },
            // {
            //     name: "Proshows 4",
            //     photo: TestImg,
            //     details:
            //         "A new music service with official albums, singles, videos, remixes, live performances and more for Android, iOS and desktop. It's all here. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
            // },
        ]
    }

    render() {
        return (
            <div className={'proshows'}>
                <img src={ProshowImg} className={'proshows-bg-image'}/>
                <div className={'bg-solid-fill'} style={{backgroundColor:'#b2aadb'}}/> {/*#f7f700*/}
                <h2 data-shadow='Proshows'>Proshows</h2>


                <ReactFullpage
                    fullpage_api
                    navigation={true}
                    licenseKey={"YOUR_KEY_HERE"}
                    render={({state,fillpageApi})=>{
                        return (
                            <ReactFullpage.Wrapper>
                                {this.data.map(item=>{
                                    return (<div className={'section'} style={{height:'100vh',display: 'flex'}}>
                                        <ProshowsCard key={item.name} {...item}/>
                                    </div>)})}

                                <div className={"section fp-auto-height"}>
                                    <Menu
                                        style={{
                                            backgroundColor: "#f08d25",
                                            marginTop: "0px",
                                            marginBottom: "0px",
                                            paddingBottom: "0px",
                                            width:'100%',
                                        }}
                                    >
                                        <Menu.Item  className={'left-menu'}>
                                            <List>
                                                <List.Item
                                                    className={"socialMedia"}
                                                    style={{ fontFamily: "'Paytone One', sans-serif" }}
                                                >
                                                    SOCIAL MEDIA
                                                </List.Item>
                                                <List.Item className={"iconList"}>
                                                    <a href="https://www.facebook.com/elan.iithyderabad">
                                                        <Icon
                                                            className={"icon1"}
                                                            name="facebook square"
                                                            size="big"
                                                            style={{ color: "black" }}
                                                        />
                                                    </a>
                                                    <a href="https://www.instagram.com/elan_nvision.iith/">
                                                        <Icon
                                                            className={"icon2"}
                                                            name="instagram"
                                                            size="big"
                                                            style={{ color: "black" }}
                                                        />
                                                    </a>
                                                    <a href="https://twitter.com/elan_nvision?lang=en">
                                                        <Icon
                                                            className={"icon3"}
                                                            name="twitter"
                                                            size="big"
                                                            style={{ color: "black" }}
                                                        />
                                                    </a>
                                                    <a href="https://www.youtube.com/user/ElanIITHyderabad">
                                                        <Icon
                                                            className={"icon3"}
                                                            name="youtube"
                                                            size="big"
                                                            style={{ color: "black" }}
                                                        />
                                                    </a>
                                                </List.Item>
                                            </List>
                                        </Menu.Item>
                                        <Menu.Menu position="right" style={{ paddingTop: "0.5%" }}>
                                            <List>
                                                <List.Item

                                                    as={NavLink}
                                                    to={'/contact'}
                                                    className={"footerText text1 footer-link"}
                                                    position="right"
                                                    style={{
                                                        fontFamily: "'Paytone One', sans-serif",
                                                        position: "absolute",
                                                        right: "0",
                                                        paddingRight: "1%",
                                                        color:'black',
                                                    }}
                                                >
                                                    CONTACT US
                                                </List.Item>
                                                <List.Item
                                                    onClick={() => this.props.setShow(true)}
                                                    className={"footerText text2"}
                                                    position="right"
                                                    style={{
                                                        fontFamily: "'Paytone One', sans-serif",
                                                        position: "absolute",
                                                        right: "0",
                                                        paddingRight: "1%",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    REGISTER
                                                </List.Item>
                                                <List.Item as={'a'}
                                                           href={"https://drive.google.com/file/d/12bEcNHHRXseIuGKPDWVm5WEioimzSc5Q/view?usp=sharing"}
                                                           target={'_blank'}
                                                           className={"footerText text3"}
                                                           position="right"
                                                           style={{
                                                               fontFamily: "'Paytone One', sans-serif",
                                                               position: "absolute",
                                                               right: "0",
                                                               paddingRight: "1%",
                                                               color:'black'
                                                           }}
                                                >
                                                    FAQ'S
                                                </List.Item>
                                            </List>
                                        </Menu.Menu>
                                    </Menu>
                                </div>
                            </ReactFullpage.Wrapper>
                        )
                    }}
                    />
            </div>
        );
    }
}

export default Proshows;